import { ASTEROID_MAX_SPEED, ASTEROID_SPAWN_INTERVAL, TICK_MS } from "./constants";
import type { AsteroidSettings } from "./maps/map-def";

/**
 * A map's own asteroid field (P11.12, 2008 req. 6.2.2), in sim terms. Only maps that set
 * `asteroids` have one; without it the legacy values apply (WorldState stays unchanged).
 */
export interface AsteroidField {
	/** Countdown reset value (effective period interval + 1); null = no asteroids at all. */
	interval: number | null;
	/** Launch speeds are drawn from [0, maxSpeed). */
	maxSpeed: number;
	/** Most asteroids on the map at once (queued ones count); null = no limit. */
	max: number | null;
}

/** Arrivals per minute → the legacy countdown (200 ↔ ~19.9 per minute). */
export function intervalForRate(perMinute: number): number | null {
	if (perMinute <= 0) return null;
	return Math.max(1, Math.round(60_000 / TICK_MS / perMinute) - 1);
}

export function asteroidField(settings: AsteroidSettings): AsteroidField {
	return {
		interval:
			settings.perMinute === undefined
				? ASTEROID_SPAWN_INTERVAL
				: intervalForRate(settings.perMinute),
		// Uniform [0, 2·average): the legacy [0, 6) averages 3.
		maxSpeed: settings.speed === undefined ? ASTEROID_MAX_SPEED : 2 * settings.speed,
		max: settings.max ?? null,
	};
}
